import React from 'react';
import { connect } from 'react-redux';
import { NavLink, withRouter } from 'react-router-dom';
import * as discountCodesActions from '../../redux/discountCodes/actions';
import DiscountCodesTable from './discountCodesTable';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import Spin from '../../components/loading';
import Pagination2 from '../../components/Pagination2';

class DiscountCodes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      itemsPerPage: 10,
      sortType: 'asc',
      sortBy: 'createdAt'
    };
  }

  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllDiscountCodes(query);
    });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllDiscountCodes(searchQuery);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  render() {
    let { discountCodesLoading, discountCodesMessage, discountCodesFailed, discountCodesError } = this.props;
    let { totalRecords } = this.props.discountCodes;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h3 className="text-right text-muted py-4">
            <div className="text-right">{locales('titles.discountsManagement')}</div>
          </h3>
          <div>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.ADD_NEW_DISCOUNT_CODE}>
              <NavLink
                to={{
                  pathname: '/discount-codes/add-or-edit',
                  editMode: false
                }}
              >
                <button className="btn btn-primary w-5 mx-1">
                  <i className="fal fa-plus mx-1" />
                  {locales('labels.newDiscount')}
                </button>
                {/* </ShowForPermission> */}
              </NavLink>
            </ShowForPermission>
          </div>
        </div>
        <section className="p-1 col-12">
          <Spin spinning={discountCodesLoading}>
            <article>
              <main className="panel panel-default">
                {discountCodesError ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {discountCodesFailed && <div className="alert alert-danger">{discountCodesMessage}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.discountsList')}
                    </div>
                    <div className="panel-body">
                      <DiscountCodesTable
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortTable={this.sortTable}
                        sortType={sortType}
                        buildSearchQuery={this.buildSearchQuery}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    discountCodesList: state.discountCodesReducer.discountCodesList,
    discountCodes: state.discountCodesReducer.discountCodes,
    discountCodesLoading: state.discountCodesReducer.discountCodesLoading,
    discountCodesMessage: state.discountCodesReducer.discountCodesMessage,
    discountCodesFailed: state.discountCodesReducer.discountCodesFailed,
    discountCodesError: state.discountCodesReducer.discountCodesError
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllDiscountCodes: query => dispatch(discountCodesActions.fetchAllDiscountCodes(query))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DiscountCodes));
